import { render, staticRenderFns } from "./MinibusPlaning.vue?vue&type=template&id=046c6de0&"
import script from "./MinibusPlaning.vue?vue&type=script&lang=js&"
export * from "./MinibusPlaning.vue?vue&type=script&lang=js&"
import style0 from "./MinibusPlaning.vue?vue&type=style&index=0&id=046c6de0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports